import { connect } from 'react-redux';
import {IState} from "./reducer";
import {Dispatch} from "redux";
import {ComponentType} from "react";
import * as actions from './actionTypes';
import { IWallet } from "../contract/config";
import { SET_isOperator } from "./actionTypes";


const mapStateToProps = (state: IState) => ({
    redux: state
});

export const mapDispatchToProps = (dispatch: Dispatch, storeData?: IState) => {
    let MsgTimer: NodeJS.Timeout | null = null;

    return {
        setWalletAddress(address: string) {
            sessionStorage.setItem("wallet_address", address);
            dispatch({
                type: actions.SET_WALLET_ADDRESS,
                data: address
            })
        },
        setToken(token: string) {
            sessionStorage.setItem("token", token);
            dispatch({
                type: actions.SET_TOKEN,
                data: token
            })
        },
        setWallet(wallet_info: IWallet|null) {
            // sessionStorage.setItem("wallet_info", JSON.stringify(wallet_info));
            sessionStorage.setItem("wallet_name", wallet_info?.name || "");
            dispatch({
                type: actions.SET_WALLET_INFO,
                data: wallet_info
            })
        },
        async checkCountry(): Promise<string> {
            /*const result = await fetch("https://geolocation-db.com/json/");
            const res = await result.json();

            if (!res) {
                return "";
            }

            const { country_code } = res;

            dispatch({
                type: actions.SET_COUNTRY_CODE,
                data: country_code
            });
            return country_code;*/
            return Promise.resolve("");
        },
        setIsOperator(isOperator: boolean) {
            dispatch({
                type: actions.SET_isOperator,
                data: isOperator
            })
        },
        setIsAdmin(isAdmin: boolean) {
            dispatch({
                type: actions.SET_isAdmin,
                data: isAdmin
            })
        }
    }
};

export interface IConnectProps extends ReturnType<typeof mapDispatchToProps> {
    redux: IState
}

export default <p>(component: ComponentType<p>) => {
    return connect(mapStateToProps, mapDispatchToProps)<ComponentType<any>>(component);
}
